export { default } from './AiQuestionCard';
